import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component ProjectTemplateAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <ProjectTemplateAddIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <ProjectTemplateAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ProjectTemplateAddIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="ProjectTemplateAddIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        d="M20 15v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm0-7a2 2 0 0 1 2 2v3h-2v-3H10v10h3v2h-3a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2zM7 5h10a2 2 0 0 1 1.995 1.85L19 7H7v12a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2m7-3a2 2 0 0 1 1.995 1.85L16 4H4v12a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
      />
    </svg>
  )
);
ProjectTemplateAddIcon.displayName = "ProjectTemplateAddIcon";
export default ProjectTemplateAddIcon;
